if (typeof JW === 'undefined') JW = {};
JW.JobFrm = function ($, jfrm)
{
    var _pri = {};
    var publ = {};

    _pri.cname = 'JOBFRM';
    _pri.opts = {
        dbg_lvl:    1,
        img_tmp_id_pref:    'img-tmp-',
        pdf_tmp_id_pref:    'pdf-tmp-',
        upl_html_url:       '/_jfrm',
        dp_opts: {
            autoclose:             true,
            calendarWeeks:         true,
            daysOfWeekHighlighted: '[0,6]',
            format:                'dd.mm.yyyy',
            language:              'de',
            todayBtn:              'linked',
            todayHighlight:        true,
            weekStart:             1,
            templates: {
                leftArrow:  '<i class="fa fa-chevron-left"></i>',
                rightArrow: '<i class="fa fa-chevron-right"></i>'
            }
        }
    };

    _pri.page       = null;
    _pri.inited     = false;
    _pri.pdf_inited = false;
    _pri.win_prev   = null;

    _pri.pdf_data = null;

    _pri.$job_pages_div    = null;
    _pri.$frm_gll_div      = null;
    _pri.$gll_src_file_btn = null;
    _pri.$job_special_inp  = null;
    _pri.$lnk_only_inp     = null;
    _pri.$lnk_only_fields  = null;
    _pri.$price_cards      = null;
    _pri.save_btn_label    = 'Anzeige speichern';

    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    publ.destroy = function()
    {
        _pri.dbg('*** destroy');
        $(document).off('keydown', _pri.keyDown);
        _pri.$frm_div.find('.acc-cls').removeData('clsacc');
        _pri.$frm_div.removeData('jw_job_frm');
        delete _pri.clsacc;
        delete publ;
        delete _pri;
    };

    _pri.init = function()
    {
        _pri.dbg('******** init()');

        if (_pri.inited)
        {
            return;
        }
        _pri.inited = true;

        _pri.$frm_div = $(jfrm);
        if (_pri.$frm_div.length == 0)
        {
            return;
        }

        _pri.page                   = JW.Page;
        _pri.uid                    = _pri.page.getUId();
        _pri.$msgs                  = $('#msgs');
        _pri.$job_pages_div         = $('#job_pages');
        _pri.clnid                  = _pri.$job_pages_div.data('clnid');
        _pri.sssk                   = _pri.$job_pages_div.data('sssk');
        _pri.$html                  = _pri.$frm_div.find('textarea[name="html"]');
        _pri.$frm_gll_div           = _pri.$frm_div.find('.jobfrm-gll');
        _pri.$gll_src_file_btn      = _pri.$frm_gll_div.find('#gll_src_file_btn');
        _pri.$job_special_inp       = _pri.$frm_div.find('input[name="job_special"]');
        _pri.dbg('    _pri.$job_special_inp: ', _pri.$job_special_inp);
        _pri.$lnk_only_inp          = _pri.$frm_div.find('input[name="lnk_only"]');
        _pri.$lnk_only_fields       = _pri.$frm_div.find('#lnk_only_fields');
        _pri.$not_lnk_only_fields   = _pri.$frm_div.find('#not_lnk_only_fields');
        _pri.$lnk_fields            = _pri.$frm_div.find('#lnk_fields');
        _pri.$price_cards           = _pri.$frm_div.find('.price-group > .card');
        _pri.$url_inp               = _pri.$frm_div.find('input[name="url"]');
        _pri.$url2_inp              = _pri.$frm_div.find('input[name="url2"]');
        _pri.$btn_sub               = $('#sub_save');
        _pri.$btn_subs              = _pri.$frm_div.find('.jfrm-save');
        _pri.$btn_prev              = $('#btn_prev');

        // the cmp form got format selection cards (260916), the adm twin still
        // uses the legacy lnk_only checkbox + format radios
        _pri.$fmt_cards             = _pri.$frm_div.find('#jfmt_cards .jfmt-card');
        _pri.has_cards              = (_pri.$fmt_cards.length > 0);
        _pri.save_nxt               = 0;

        // $('#agb_row').hide();

        // done by page yet ... in case of problems add .nai class
        // $('.datepicker').datepicker(_pri.opts.dp_opts);
        // done by jw_tmc yet ... in case of problems add .nai class
        // _pri.initTinyMCE();

        _pri.initLnkOnly();
        _pri.initGll();
        _pri.initClsAcc();
        if (_pri.has_cards)
        {
            _pri.initFormatCards();
        }
        else
        {
            _pri.initFormats();
        }
        _pri.initGeoFields();
        _pri.setLnkOnly();
        _pri.initSave();
        _pri.initPreview();

        if (!_pri.has_cards && _pri.$btn_sub.length > 0)
        {
            if (_pri.$frm_div.data('new') == '1')
            {
                _pri.save_btn_label = 'Anzeige buchen';
            }
            _pri.$btn_sub.html(_pri.save_btn_label);
        }

        _pri.dbg('    _pri.$price_cards: ', _pri.$price_cards);

        _pri.$frm_div.data('jw_job_frm', publ);
    }

    _pri.initFormats = function()
    {
        _pri.$job_format_inp        = _pri.$frm_div.find('input[name="job_format"]');
        _pri.$job_format_div_html   = _pri.$frm_div.find('#job_format_html');
        _pri.$job_format_div_pdf    = _pri.$frm_div.find('#job_format_pdf');
        _pri.$pdfwrp                = _pri.$job_format_div_pdf.find('.pdfwrp');

        _pri.$job_format_inp.on('change', function() {
            var $this = $(this);
            _pri.dbg('*** job_format change() $this: ' + $this);
            _pri.dbg('    checked: ', $this.prop('checked'));
            _pri.dbg('    id: ', $this.attr('id'));
            if ($this.attr('id') == 'job_formathtml' && $this.prop('checked'))
            {
                _pri.setFormat('job_formathtml');
            }
            else if ($this.attr('id') == 'job_formatpdf' && $this.prop('checked'))
            {
                _pri.setFormat('job_formatpdf');
            }
            else
            {
                _pri.setFormat('');
            }
        });

        _pri.$job_format_inp.trigger('change');
    };

    _pri.setFormat = function(format)
    {
        if (format === '')
        {
            _pri.$job_format_div_html.collapse('hide');
            _pri.$job_format_div_pdf.collapse('hide');
        }
        else if(format === 'job_formathtml')
        {
            _pri.$job_format_div_html.collapse('show');
            _pri.$job_format_div_pdf.collapse('hide');
        }
        else if(format === 'job_formatpdf')
        {
            _pri.$job_format_div_html.collapse('hide');
            _pri.$job_format_div_pdf.collapse('show');
            if (!_pri.pdf_inited)
            {
                _pri.pdf_inited = true;
                // _pri.page.initPdfWrps('#job_format_pdf');
                var $pdfwrps = $('#job_format_pdf').find('.pdfwrp.nai');
                if (0 < $pdfwrps.length)
                {
                    _pri.dbg('******** init Pdfs ...');
                    $.each($pdfwrps, function(k, v) {
                        _pri.dbg('    init JW.Pdf() ...');
                        // $(v).data('cbd-state', 'changed');
                        _pri.setDataAttr($(v), 'cbd-state', 'changed');
                        JW.Pdf(jQuery, v);
                    });
                }
                else
                {
                    _pri.dbg('    ... no uninitialized pdf wrapper found ... return.');
                }
            }
        }
    };

    // format selection cards (cmp form and adm twin): one hidden
    // input[name=job_format], a card per format, sections
    // #jfmt_sec_html/_pdf/_lnk plus the url field block #lnk_fields
    // (hidden in LNK mode)
    _pri.initFormatCards = function()
    {
        _pri.$job_format_inp = _pri.$frm_div.find('input[name="job_format"]');
        _pri.$sec_html       = _pri.$frm_div.find('#jfmt_sec_html');
        _pri.$sec_pdf        = _pri.$frm_div.find('#jfmt_sec_pdf');
        _pri.$sec_lnk        = _pri.$frm_div.find('#jfmt_sec_lnk');

        _pri.setFormatCard = function(val)
        {
            _pri.$job_format_inp.val(val);

            $.each(_pri.$fmt_cards, function(k, v) {
                var $card = $(v);
                var $icon = $card.find('.card-footer i');
                var $lbl  = $card.find('.card-footer span');
                if ($card.data('val') == val)
                {
                    $card.addClass('checked');
                    $icon.removeClass('fa-circle-o').addClass('fa-check-circle text-primary');
                    $lbl.html('Gewählt');
                }
                else
                {
                    $card.removeClass('checked');
                    $icon.removeClass('fa-check-circle text-primary').addClass('fa-circle-o');
                    $lbl.html('Wählen');
                }
            });

            _pri.$sec_html.collapse(val == 2 ? 'show' : 'hide');
            _pri.$sec_pdf.collapse(val == 3 ? 'show' : 'hide');
            _pri.$sec_lnk.collapse(val == 1 ? 'show' : 'hide');
            _pri.$lnk_fields.collapse(val == 1 ? 'hide' : 'show');

            if (val == 1)
            {
                _pri.$btn_prev.addClass('d-none');
            }
            else
            {
                _pri.$btn_prev.removeClass('d-none');
            }

            if (val == 3 && !_pri.pdf_inited)
            {
                _pri.pdf_inited = true;
                var $pdfwrps = _pri.$sec_pdf.find('.pdfwrp.nai');
                $.each($pdfwrps, function(k, v) {
                    _pri.dbg('    init JW.Pdf() ...');
                    _pri.setDataAttr($(v), 'cbd-state', 'changed');
                    JW.Pdf(jQuery, v);
                });
            }
        };

        _pri.$fmt_cards.on('click', function() {
            $('#jfmt_cards').removeClass('is-invalid');
            _pri.setFormatCard($(this).data('val'));
        });

        var cur = parseInt(_pri.$job_format_inp.val(), 10);
        if (cur > 0)
        {
            _pri.setFormatCard(cur);
        }
    };

    _pri.initGeoFields = function()
    {
        var $geo = $('#geo');
        var $wrp = $('#geo_wrp');
        if ($geo.length > 0 && $wrp.length > 0)
        {
            $geo.on('change', function() {
                if ($geo.prop('checked'))
                {
                    $wrp.removeClass('op03');
                }
                else
                {
                    $wrp.addClass('op03');
                }
            });
            $geo.trigger('change');
        }
    };

    _pri.initLnkOnly = function()
    {
        _pri.isLnkOnly = function()
        {
            if (_pri.has_cards)
            {
                return (_pri.getJobFormat() === 1);
            }
            return _pri.$lnk_only_inp.is(':checked');
        };

        _pri.setLnkOnly = function(e)
        {
            if (_pri.$lnk_only_inp.length == 0)
            {
                return;
            }
            if (_pri.$lnk_only_inp.is(':checked') && !_pri.$lnk_only_fields.hasClass('show'))
            {
                _pri.$lnk_only_fields.removeClass('collapsing').collapse('show');
                _pri.$lnk_fields.removeClass('collapsing').collapse('hide');
                _pri.$not_lnk_only_fields.removeClass('collapsing').collapse('hide');
                _pri.$btn_prev.addClass('d-none');
            }
            else if (!_pri.$lnk_only_inp.is(':checked') && _pri.$lnk_only_fields.hasClass('show'))
            {
                _pri.$lnk_only_fields.removeClass('collapsing').collapse('hide');
                _pri.$lnk_fields.removeClass('collapsing').collapse('show');
                _pri.$not_lnk_only_fields.removeClass('collapsing').collapse('show');
                _pri.$btn_prev.removeClass('d-none');
            }
        };

        _pri.$lnk_only_fields.on('hidden.bs.collapse shown.bs.collapse', function(e) {
            if (_pri.$lnk_only_inp.is(':checked') && !_pri.$lnk_only_fields.hasClass('show'))
            {
                _pri.$lnk_only_fields.removeClass('collapsing').collapse('show');
            }
            else if (!_pri.$lnk_only_inp.is(':checked') && _pri.$lnk_only_fields.hasClass('show'))
            {
                _pri.$lnk_only_fields.removeClass('collapsing').collapse('hide');
            }
        });

        _pri.$lnk_only_inp.on('change', _pri.setLnkOnly);
    };

    _pri.initGll = function()
    {
        _pri.isGll = function()
        {
            return (_pri.$job_special_inp.val() == '2' || _pri.$job_special_inp.val() == '4');
        };

        _pri.$job_special_inp.on('change', function(e) {
            _pri.dbg('*** job_special change()');
            var val = $(this).val();
            if (val == '2' || val == '4')
            {
                _pri.$frm_gll_div.collapse('show');
            }
            else
            {
                _pri.$frm_gll_div.collapse('hide');
            }
        });

        _pri.$price_cards.click(function(e) {
            _pri.dbg('*** price card click()');
            var $this = $(this);
            if ($this.hasClass('dis'))
            {
                return;
            }
            var val = $this.find('.card-footer[role="button"]').data('val');
            _pri.dbg('    val: ', val);
            _pri.$job_special_inp.val(val).trigger('change');
            $.each(_pri.$price_cards, function(k, v) {
                var $card = $(v);
                var $btn = $card.find('.card-footer[role="button"]');
                if ($btn.data('val') == val)
                {
                    $btn.find('span > i').removeClass('fa-square-o').addClass('fa-check-square-o');
                    $card.addClass('checked');
                }
                else
                {
                    $btn.find('span > i').removeClass('fa-check-square-o').addClass('fa-square-o');
                    $card.removeClass('checked');
                }
            })
        });

        var $price_checked = $('.price-group > .card.checked');
        if ($price_checked.length > 0)
        {
            $price_checked.trigger('click');
        }
    };

    _pri.initClsAcc = function()
    {
        var $acc = _pri.$frm_div.find('.acc-cls');
        if (1 == $acc.length)
        {
            _pri.dbg('*** init ClsAcc ...');
            _pri.clsacc = JW.ClsAcc(jQuery, $acc[0]);
        }
    };

    _pri.getJobFormat = function()
    {
        if (_pri.has_cards)
        {
            var val = parseInt(_pri.$job_format_inp.val(), 10);
            return (val > 0 ? val : 0);
        }

        if (_pri.isLnkOnly())
        {
            return 1;
        }
        else if (_pri.$frm_div.find('#job_formathtml').prop('checked'))
        {
            return 2;
        }
        else if (_pri.$frm_div.find('#job_formatpdf').prop('checked'))
        {
            return 3;
        }

        return 0;
    };

    _pri.keyDown = function(e) {

        var key = undefined;
        var possible = [ e.key, e.keyIdentifier, e.keyCode, e.which ];

        while (key === undefined && possible.length > 0)
        {
            key = possible.pop();
        }

        if (key && (key == '115' || key == '83' ) && (e.ctrlKey || e.metaKey) && !(e.altKey))
        {
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();

            _pri.dbg("Ctrl-s pressed");

            _pri.save();

            return false;
        }

        return true;
    };

    _pri.preValidateJobForm = function()
    {
        var errmsgs = [];
        var $scroll_to = null;
        var $hdl = _pri.$frm_div.find('#hdl');

        if (_pri.$job_special_inp.val() != '1' && _pri.$job_special_inp.val() != '2' && _pri.$job_special_inp.val() != '4')
        {
            errmsgs.push('Bitte wählen Sie eine Anzeigenvariante');
            $('.price-group').addClass('is-invalid');
            $('[for="job_special"]').addClass('is-invalid');
            $scroll_to = $('.price-group');
        }

        if (_pri.isGll())
        {
            if ($('#pv_gll_txt').text() == '')
            {
                var $gll_file = $('.jobfrm-gll').find('input[name="gll-file0"]');
                if ($gll_file.length == 0 || $gll_file.val().length < 8)
                {
                    errmsgs.push('Bitte wählen Sie die Galerie-Anzeigen&shy;grafik aus.');
                    $scroll_to = $('input.f-lbl');
                    $scroll_to.addClass('is-invalid');
                }
            }
        }

        if ($hdl.val().length < 8)
        {
            if ($scroll_to == null)
            {
                $scroll_to = $hdl;
            }
            errmsgs.push('Bitte geben Sie die Stellen&shy;bezeichnung bzw. den Titel der Anzeige ein. (min. 8 Zeichen)');
            $hdl.addClass('is-invalid');
        }

        if (_pri.isLnkOnly())
        {
            var $dsc = _pri.$frm_div.find('#dsc');
            var $url = _pri.$url2_inp;

            if ($dsc.val().length < 16)
            {
                if ($scroll_to == null)
                {
                    $scroll_to = $dsc;
                }
                errmsgs.push('Bitte geben Sie für die Suchergebnisliste noch eine etwas aus&shy;führ&shy;lichere Be&shy;schrei&shy;bung Ihres An&shy;gebots ein. (min. 16 Zeichen)');
                $dsc.addClass('is-invalid');
            }

            if ($url.val() == '')
            {
                if ($scroll_to == null)
                {
                    $scroll_to = $url;
                }
                errmsgs.push('Bitte geben Sie die URL ein, zu der ein Klick auf Ihre Anzeige weiterleiten soll.');
                $url.addClass('is-invalid');
            }
        }
        else
        {
            if (_pri.getJobFormat() === 0)
            {
                errmsgs.push('Bitte wählen Sie das gewünschte Anzeigenformat aus.');
                if (_pri.has_cards)
                {
                    if ($scroll_to == null)
                    {
                        $scroll_to = $('#jfmt_cards');
                    }
                    $('#jfmt_cards').addClass('is-invalid');
                }
                else
                {
                    if ($scroll_to == null)
                    {
                        $scroll_to = _pri.$frm_div.find('#job_formathtml');
                    }
                    _pri.$frm_div.find('#job_formathtml').addClass('is-invalid');
                    _pri.$frm_div.find('#job_formatpdf').addClass('is-invalid');
                }
            }
            else if (_pri.getJobFormat() === 2) // html
            {
                var html_str = _pri.$html.val();
                if (html_str.length < 20)
                {
                    errmsgs.push('Der Anzeigentext ist zu kurz.');
                }
                else if (html_str.length > 15000)
                {
                    errmsgs.push('Der Anzeigentext ist zu lang.');
                }
            }
        }

        if (errmsgs.length > 0)
        {
            JW.Modal.setMask(1, 0, 0);
            JW.Modal.showMsg('<ul class="list-std"><li>' + errmsgs.join('</li><li>') + '</li></ul>', 'Bitte überprüfen', 'mwp-640');

            _pri.dbg('    srollto:', $scroll_to);
            if ($scroll_to != null && $scroll_to.length > 0)
            {
                $('html,body').animate({
                    scrollTop: ($scroll_to.offset().top - $('#nav-top').outerHeight(true) - 100)
                }, 350);
            }
        }
        else
        {

            JW.Modal.setMask(1, 1, 1);
            if (_pri.getJobFormat() == 3)
            {
                _pri.getPdfData();
            }
            else
            {
                _pri.saveForm();
            }
        }
    };

    _pri.getPdfData = function(preview)
    {
        // data-cbd-state has been set by:
        // * pdf in cbd mode on load data
        var preview    = typeof preview === 'undefined' ? false : true; // unused - we have to use getPdfDataSync to avoid pop up blockers ... so that preview switch here will be removed soon ...
        var $pdfwrps   = _pri.$frm_div.find('.pdfwrp[data-cbd-state="changed"]');
        var pdf_cnt    = $pdfwrps.length;
        var pdf_data   = [];
        var $scroll_to = null;

        var setPdfData = function(o)
        {
            pdf_data.push(o);

            if (pdf_data.length == pdf_cnt)
            {
                _pri.dbg('*** setPdfData() - getPdfData() done ... ');
                _pri.dbg('    pdf_data: ', pdf_data);

                var is_err = false;
                var errstr = '';

                $.each(pdf_data, function(k, v) {
                    if (typeof v !== 'object'|| typeof v.uid === 'undefined')
                    {
                        is_err = true;
                    }
                    else if (typeof v.errno !== 'undefined' && v.errno > 0)
                    {
                        is_err = true;
                        if (v.errno == 8)
                        {
                            errstr = 'Bitte ersetzen Sie die Platzhalter-PDF-Datei durch Ihre PDF-Datei.<br>Klicken Sie dazu auf das PDF-Logo in der Mitte der PDF-Anzeige und wählen Sie Ihr Pdf aus.';
                            $scroll_to = _pri.$frm_div.find('.pdfwrp');
                            $('#pdflbl').addClass('is-invalid');
                        }
                    }
                    else if (v.fdata == '' || v.fname == '')
                    {
                        is_err = true;
                    }
                });

                if (is_err)
                {
                    // JW.Modal.setMask(0, 0, 0);
                    // _pri.page.showErrMsg(errstr, _pri.$msgs);
                    if (errstr == '')
                    {
                        errstr = 'Beim Speichern ist leider ein Fehler aufgetreten<br>Bitte versuchen Sie es später noch einmal.';
                    }
                    JW.Modal.setMask(2, 2, 0);
                    JW.Modal.showMsg(errstr, 'Bitte überprüfen', 'mwp-640');
                    _pri.dbg('    srollto:', $scroll_to);
                    if ($scroll_to != null && $scroll_to.length > 0)
                    {
                        $scroll_to.addClass('is-invalid');
                        _pri.dbg('    srollto:', $scroll_to);
                        $('html,body').animate({
                            scrollTop: ($scroll_to.offset().top - $('#nav-top').outerHeight(true) - 100)
                        }, 350);
                    }
                }
                else
                {
                    _pri.pdf_data = pdf_data;
                    if (!preview)
                    {
                        _pri.saveForm();
                    }
                    else
                    {
                        _pri.savePreviewPdf();
                    }
                }
            }
        };

        if ($pdfwrps.length > 0)
        {
            // JW.Modal.setMask(1, 1, 1);

            $.each($pdfwrps, function(k, v) {

                var $this = $(v);
                var pdfv = $this.data('pdfv');
                _pri.dbg('    pdfv: ', pdfv);

                if (typeof pdfv === 'object')
                {
                    var uid = pdfv.getUId();
                    _pri.dbg('    uid: ', uid);

                    //Give ID to pdf
                    $this.attr('id', _pri.opts.pdf_tmp_id_pref + uid);
                    pdfv.getUplPdf(setPdfData);
                }
                else
                {
                    setPdfData({ uid: $(v).data('uid'), fname: '', fdata: '', errno: 1, errstr: 'pdfv not found' });
                }
            });
        }
        else
        {
            // errstr = 'Bitte ersetzen Sie die Platzhalter-PDF-Datei durch Ihre PDF-Datei.<br>Klicken Sie dazu auf das PDF-Logo in der Mitte der PDF-Anzeige und wählen Sie Ihr Pdf aus.';
            // $('#pdflbl').addClass('is-invalid');
            // JW.Modal.setMask(2, 2, 0);
            // JW.Modal.showMsg(errstr, 'Bitte überprüfen', 'mwp-640');
            // $scroll_to = _pri.$frm_div.find('.pdfwrp');
            // if ($scroll_to.length > 0)
            // {
            //     $scroll_to.addClass('is-invalid');
            //     _pri.dbg('    srollto:', $scroll_to);
            //     $('html,body').animate({
            //         scrollTop: ($scroll_to.offset().top - $('#nav-top').outerHeight(true) - 100)
            //     }, 350);
            // }
            _pri.dbg('    no changed pdfs calling saveForm() ...');
            if (!preview)
            {
                _pri.saveForm();
            }
            else
            {
                _pri.savePreviewPdf();
            }
        }
    };

    _pri.getPdfDataSync = function()
    {
        // data-cbd-state has been set by:
        // * pdf in cbd mode on load data
        var $pdfwrps   = _pri.$frm_div.find('.pdfwrp[data-cbd-state="changed"]');
        var pdf_cnt    = $pdfwrps.length;
        var pdf_data   = [];
        var $scroll_to = null;

        var setPdfDataSync = function(o)
        {
            pdf_data.push(o);
        };

        _pri.checkPdfDataSync = function()
        {
            var ret = 0;
            if (pdf_data.length == pdf_cnt)
            {
                _pri.dbg('*** setPdfDataSync() - getPdfDataSync() done ... ');
                _pri.dbg('    pdf_data: ', pdf_data);

                var is_err = false;
                var errstr = '';

                $.each(pdf_data, function(k, v) {
                    if (typeof v !== 'object'|| typeof v.uid === 'undefined')
                    {
                        is_err = true;
                    }
                    else if (typeof v.errno !== 'undefined' && v.errno > 0)
                    {
                        is_err = true;
                        if (v.errno == 8)
                        {
                            errstr = 'Bitte ersetzen Sie die Platzhalter-PDF-Datei durch Ihre PDF-Datei.<br>Klicken Sie dazu auf das PDF-Logo in der Mitte der PDF-Anzeige und wählen Sie Ihr Pdf aus.';
                            $scroll_to = _pri.$frm_div.find('.pdfwrp');
                            $('#pdflbl').addClass('is-invalid');
                        }
                    }
                    else if (v.fdata == '' || v.fname == '')
                    {
                        is_err = true;
                    }
                });

                if (is_err)
                {
                    if (errstr == '')
                    {
                        errstr = 'Beim Speichern ist leider ein Fehler aufgetreten<br>Bitte versuchen Sie es später noch einmal.';
                    }
                    JW.Modal.setMask(2, 2, 0);
                    JW.Modal.showMsg(errstr, 'Bitte überprüfen', 'mwp-640');
                    _pri.dbg('    srollto:', $scroll_to);
                    if ($scroll_to != null && $scroll_to.length > 0)
                    {
                        $scroll_to.addClass('is-invalid');
                        _pri.dbg('    srollto:', $scroll_to);
                        $('html,body').animate({
                            scrollTop: ($scroll_to.offset().top - $('#nav-top').outerHeight(true) - 100)
                        }, 350);
                    }

                    ret = -1;
                }
                else
                {
                    _pri.pdf_data = pdf_data;
                    ret = 1;
                }
            }

            return ret;
        };

        if ($pdfwrps.length > 0)
        {
            $.each($pdfwrps, function(k, v) {

                var $this = $(v);
                var pdfv = $this.data('pdfv');
                _pri.dbg('    pdfv: ', pdfv);

                if (typeof pdfv === 'object')
                {
                    var uid = pdfv.getUId();
                    _pri.dbg('    uid: ', uid);

                    //Give ID to pdf
                    $this.attr('id', _pri.opts.pdf_tmp_id_pref + uid);
                    pdfv.getUplPdf(setPdfDataSync);
                }
                else
                {
                    setPdfDataSync({ uid: $(v).data('uid'), fname: '', fdata: '', errno: 1, errstr: 'pdfv not found' });
                }
            });

            return false;
        }
        else
        {
            return true;
        }
    };

    _pri.initPreview = function()
    {
        _pri.$btn_prev.on('click', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();

            if (_pri.preValidatePreview())
            {
                JW.Modal.setMask(1, 1, 1);
                if (_pri.getJobFormat() == 3)
                {
                    _pri.getPdfDataSync();
                    _pri.ivid = setInterval(function() {
                        _pri.dbg('*** inside Interval ...');
                        var ret = _pri.checkPdfDataSync();
                        if (ret !== 0)
                        {
                            clearInterval(_pri.ivid);
                            if (ret === 1)
                            {
                                _pri.win_prev = window.open('', 'Job_Vorschaufenster_jobwoche_de');
                                if(!_pri.win_prev || _pri.win_prev.closed || typeof _pri.win_prev.closed === 'undefined')
                                {
                                    _pri.dbg('!!! POPUP BLOCKED!');
                                }
                                _pri.savePreview();
                            }
                        }
                    }, 100);
                }
                else
                {
                    _pri.win_prev = window.open('', 'Job_Vorschaufenster_jobwoche_de');
                    if(!_pri.win_prev || _pri.win_prev.closed || typeof _pri.win_prev.closed === 'undefined')
                    {
                        _pri.dbg('!!! POPUP BLOCKED!');
                    }
                    _pri.savePreview();
                }


            }

            // _pri.dbg('    win_prev: ', _pri.win_prev, typeof _pri.win_prev);
            // if (typeof _pri.win_prev === 'object')
            // {
            //     _pri.dbg('    OK, window is object ...');
            //     _pri.dbg('    typeof win.location: ', typeof _pri.win_prev.location);
            // }
            // else
            // {
            //     _pri.dbg('    !!!NOPE!!! win is not an object!!!');
            // }
            //
            // if (typeof _pri.win_prev === 'object' && _pri.win_prev != null && _pri.win_prev.closed)
            // {
            //     delete _pri.win_prev;
            //     _pri.win_prev = null;
            // }

            return false;
        });
    };

    _pri.preValidatePreview = function()
    {
        var errmsgs = [];
        var $scroll_to = null;
        var $hdl = _pri.$frm_div.find('#hdl');

        if (_pri.$job_special_inp.val() != '1' && _pri.$job_special_inp.val() != '2' && _pri.$job_special_inp.val() != '4')
        {
            errmsgs.push('Bitte wählen Sie eine Anzeigenvariante');
            $('.price-group').addClass('is-invalid');
            $('[for="job_special"]').addClass('is-invalid');
            $scroll_to = $('.price-group');
        }

        if ($hdl.val().length < 8)
        {
            if ($scroll_to == null)
            {
                $scroll_to = $hdl;
            }
            errmsgs.push('Bitte geben Sie die Stellen&shy;bezeichnung bzw. den Titel der Anzeige ein. (min. 8 Zeichen)');
            $hdl.addClass('is-invalid');
        }

        if (_pri.isLnkOnly())
        {
            errmsgs.push('Diese Form der Anzeige hat keine Vorschau, da sie nur in den Suchergebnislisten erscheint, und direkt auf Ihre Anzeige verlinkt.');
        }
        else
        {
            if (_pri.getJobFormat() === 0)
            {
                errmsgs.push('Bitte wählen Sie das gewünschte Anzeigenformat aus.');
                if (_pri.has_cards)
                {
                    if ($scroll_to == null)
                    {
                        $scroll_to = $('#jfmt_cards');
                    }
                    $('#jfmt_cards').addClass('is-invalid');
                }
                else
                {
                    if ($scroll_to == null)
                    {
                        $scroll_to = _pri.$frm_div.find('#job_formathtml');
                    }
                    _pri.$frm_div.find('#job_formathtml').addClass('is-invalid');
                    _pri.$frm_div.find('#job_formatpdf').addClass('is-invalid');
                }
            }
            else if (_pri.getJobFormat() === 2) // html
            {
                var html_str = _pri.$html.val();
                if (html_str.length < 20)
                {
                    errmsgs.push('Der Anzeigentext ist zu kurz.');
                }
                else if (html_str.length > 15000)
                {
                    errmsgs.push('Der Anzeigentext ist zu lang.');
                }
            }
        }

        if (errmsgs.length > 0)
        {
            JW.Modal.setMask(1, 0, 0);
            JW.Modal.showMsg('<ul class="list-std"><li>' + errmsgs.join('</li><li>') + '</li></ul>', 'Bitte überprüfen', 'mwp-640');

            _pri.dbg('    srollto:', $scroll_to);
            if ($scroll_to != null && $scroll_to.length > 0)
            {
                $('html,body').animate({
                    scrollTop: ($scroll_to.offset().top - $('#nav-top').outerHeight(true) - 100)
                }, 350);
            }

            return false;
        }
        else
        {
            return true;
        }
    };

    // let's use sync methods to avoid nasty pop up blockers ...
    _pri.savePreviewPdf = function()
    {
        _pri.dbg('*** savePreviewPdf()');
        _pri.savePreview();
    };

    _pri.savePreview = function()
    {
        _pri.dbg('*** savePreview()');

        var form_data = new FormData();

        var fd = {};
        fd['clnid']      = _pri.clnid;
        fd['sssk']       = _pri.sssk;
        fd['state_user'] = $('#state_user').is(':checked') ? '1' : '0';
        fd['agb']        = $('#agb_inp').is(':checked') ? '1' : '0';
        fd['job_format'] = _pri.getJobFormat();

        if (fd['job_format'] == 3)
        {
            if (_pri.pdf_data != null)
            {
                $.each(_pri.pdf_data, function(k, v) {
                    form_data.append(_pri.opts.pdf_tmp_id_pref + v.uid, v.fdata);
                    form_data.append(_pri.opts.pdf_tmp_id_pref + 'name-' + v.uid, v.fname);
                });
            }
        }

        $.extend(fd, _pri.getFormData(true));

        var p;
        for (p in fd)
        {
            if (fd.hasOwnProperty(p))
            {
                form_data.append(p, fd[p]);
            }
        }

        // _pri.dbg('    form_data: ', form_data);

        _pri.win_prev = window.open('', 'Job_Vorschaufenster_jobwoche_de');
        // _pri.dbg('    win_prev: ', _pri.win_prev, typeof _pri.win_prev);
        // if (typeof _pri.win_prev === 'object')
        // {
        //     _pri.dbg('    OK, window is object ...');
        //     _pri.dbg('    typeof win.location: ', typeof _pri.win_prev.location);
        // }
        // else
        // {
        //     _pri.dbg('    !!!NOPE!!! win is not an object!!!');
        // }
        //
        // if (typeof _pri.win_prev === 'object' && _pri.win_prev != null && _pri.win_prev.closed)
        // {
        //     delete _pri.win_prev;
        //     _pri.win_prev = null;
        // }

        // var headers = new Headers({"HTTP-X-REQUESTED-WITH": "XMLHttpRequest"});
        var xhr = new XMLHttpRequest();
        xhr.withCredentials = false;
        xhr.open('POST', _pri.opts.upl_html_url);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.addEventListener("load", function(e) {
            _pri.dbg('*** savePreview() on load e, xhr: ', e, xhr);
            _pri.onJsonResponse(xhr, 'savePreview');
        });

        xhr.send(form_data);
    };

    _pri.onJsonResponse = function(xhr, call)
    {
        var msg = '';
        var hdl = '';
        var ret = null;

        if (xhr.status != 200)
        {
            hdl = 'Leider ist bei der Datenübertragung ein Fehler aufgetreten<br>Bitte versuchen Sie es später noch einmal.';
            msg = 'Bitte versuchen Sie es später erneut.';
        }
        else
        {
            var ret = JSON.parse(xhr.responseText);
        }

        if (typeof ret === 'object' && typeof ret.state !== 'undefined' && typeof ret.state.state !== 'undefinded')
        {
            // here only an ajx redirect to success page - that's why return ...
            if (typeof ret.parts !== 'undefined' && $.isPlainObject(ret.parts))
            {
                _pri.dbg('    parts ...');
                $.each(ret.parts, function(k, v) {
                    _pri.dbg('        ' + k);
                    JW.Page.setPart(k, v);
                });

                $scroll_to = $('#job_pages');
                _pri.dbg('    srollto #job_pages');
                $('html,body').animate({
                    scrollTop: ($scroll_to.offset().top - $('#nav-top').outerHeight(true) - 100)
                }, 350);

                JW.Modal.setMask(0, 0, 0);
                return;
            }

            if (ret.state.state.toString() === '0')
            {
                _pri.dbg('    state OK ...');
                switch (call)
                {
                    case 'saveForm':
                        // draft saved: continue per clicked button - nxt=1 opens
                        // a fresh form, nxt=0 goes to the booking checkout
                        if (typeof ret.job_saved === 'object' && ret.job_saved !== null && ret.job_saved.draft == 1)
                        {
                            window.location.href = (_pri.save_nxt == 1 ? '/kunden/job' : '/kunden/job-buchen');
                            return;
                        }

                        if (ret.dmsgs.length > 1)
                        {
                            hdl = ret.dmsgs.shift();
                        }
                        msg = ret.dmsgs.join('<br>');
                    break;
                    case 'savePreview':
                        var win_url = '/kunden/job-vorschau/' + _pri.sssk;
                        _pri.dbg('    2222 OK - redirect preview window ...');
                        _pri.dbg('    2222 win_prev: ', _pri.win_prev, typeof _pri.win_prev);
                        if (typeof _pri.win_prev === 'object' && typeof _pri.win_prev.closed !== 'undefined' && !_pri.win_prev.closed)
                        {
                            _pri.dbg('    2222 OK, window is object ...');
                            _pri.dbg('    2222 typeof win.location: ', typeof _pri.win_prev.location);
                            _pri.win_prev.location.href = win_url;
                        }
                        else
                        {
                            _pri.dbg('    2222 !!!NOPE!!! win is not an object!!!');
                            _pri.win_prev = window.open(win_url, 'Job_Vorschaufenster_jobwoche_de');
                        }

                        JW.Modal.setMask(0, 0, 0);
                    break;
                    default:

                    break;
                }
            }
            else
            {
                _pri.dbg('    state ERR ...');
                hdl = 'Bitte überprüfen';
                msg = '<ul class="list-std"><li>' + ret.emsgs.join('</li><li>') + '</li></ul>';
                if (typeof ret.invalids !== 'undefined' && $.isArray(ret.invalids) && ret.invalids.length > 0)
                {
                    _pri.dbg('    invalids ...');

                    var $scroll_to = null;

                    $.each(ret.invalids, function(k, v) {
                        // _pri.dbg(k);
                        _pri.dbg('        ' + v);

                        if (v == 'job_special')
                        {
                            $('.price-group').addClass('is-invalid');
                            $('[for="job_special"]').addClass('is-invalid');
                            if (k == 0)
                            {
                                $scroll_to = $('.price-group');
                            }
                        }
                        else if (v.substr(0, 3) == 'cl_')
                        {
                            _pri.clsacc.setInvalid(v);
                            if (k == 0)
                            {
                                $scroll_to = _pri.clsacc.getSection(v);
                            }
                        }
                        else
                        {
                            var $elm = $('input[name="' + v + '"]');
                            if ($elm.length > 0)
                            {
                                $elm.addClass('is-invalid');
                                if (k == 0)
                                {
                                    $scroll_to = $elm;
                                }
                                return true;
                            }

                            $elm = $('textarea[name="' + v + '"]');
                            if ($elm.length > 0)
                            {
                                $elm.addClass('is-invalid');
                                if (k == 0)
                                {
                                    $scroll_to = $elm;
                                }
                                return true;
                            }

                            $elm = $('select[name="' + v + '"]');
                            if ($elm.length > 0)
                            {
                                $elm.siblings('.vinp').addClass('is-invalid'); // visual input to take borders etc.
                                if (k == 0)
                                {
                                    $scroll_to = $elm;
                                }
                                return true;
                            }
                        }
                    });

                    _pri.dbg('    srollto:', $scroll_to);
                    if ($scroll_to != null && $scroll_to.length > 0)
                    {
                        _pri.dbg('    srollto:', $scroll_to);
                        $('html,body').animate({
                            scrollTop: ($scroll_to.offset().top - $('#nav-top').outerHeight(true) - 100)
                        }, 350);
                    }
                }
            }

            if (typeof ret.srcs === 'object') // $ret['srcs']['pv_gll_txt']
            {
                if (typeof ret.srcs.txts === 'object')
                {
                    if (typeof ret.srcs.txts.pv_gll_txt === 'string')
                    {
                        if (ret.srcs.txts.pv_gll_txt != '')
                        {
                            $('#pv_gll_txt').html(ret.srcs.txts.pv_gll_txt);
                            $('#pv_gll').collapse('show');
                            $('#gll_upl_lbl').html('Neue Galerie-Grafik hochladen');
                            _pri.$gll_src_file_btn.data('fbtn').reset();
                        }
                        else
                        {
                            $('#pv_gll_txt').html('');
                            $('#pv_gll').collapse('hide');
                            // $('#gll_upl_lbl').html('Galerie-Grafik hochladen');
                            // _pri.$gll_src_file_btn.data('fbtn').reset();
                        }
                    }
                }

                if (typeof ret.srcs.pdfs === 'object')
                {
                    for (p in ret.srcs.pdfs)
                    {
                        if (ret.srcs.pdfs.hasOwnProperty(p))
                        {
                            var $elm = $('#' + p);
                            _pri.setDataAttr($elm, 'src', ret.srcs.pdfs[p]);
                            _pri.setDataAttr($elm, 'cbd-state', '');
                            $elm.removeAttr('id');
                        }
                    }
                }
            }

            if (typeof ret.clnid !== 'undefined')
            {
                _pri.clnid = ret.clnid;
            }
        }
        else
        {
            hdl = 'Leider ist ein Fehler aufgetreten.';
            msg = 'Bitte versuchen Sie es später erneut.';
        }

        if (msg != '')
        {
            JW.Modal.setMask(2, 2, 0);
            JW.Modal.showMsg(msg, hdl, 'mwp-640');
        }
    };

    _pri.initSave = function()
    {
        // $(document).keydown(_pri.keyDown);
        _pri.$btn_sub.on('click', _pri.save);

        // cmp booking buttons: data-nxt=1 books and reloads a fresh form,
        // data-nxt=0 books and continues to the checkout
        _pri.$btn_subs.on('click', function() {
            _pri.save_nxt = $(this).data('nxt');
            _pri.save();
        });
    };

    _pri.save = function()
    {
        _pri.dbg('*** save()');
        if ($('body').hasClass('mdl-open'))
        {
            return;
        }

        _pri.$msgs.html('');
        $('.is-invalid').removeClass('is-invalid');
        _pri.pdf_data = null;
        _pri.preValidateJobForm();
    };

    _pri.saveForm = function()
    {
        _pri.dbg('*** saveForm()');

        var form_data = new FormData();

        var fd = {};
        fd['clnid']      = _pri.clnid;
        fd['sssk']       = _pri.sssk;
        fd['state_user'] = $('#state_user').is(':checked') ? '1' : '0';
        fd['agb']        = $('#agb_inp').is(':checked') ? '1' : '0';

        if (_pri.$frm_div.find('#job_formatpdf').prop('checked'))
        {
            if (_pri.pdf_data != null)
            {
                // _pri.dbg('    pdf data is NOT null');
                $.each(_pri.pdf_data, function(k, v) {
                    _pri.dbg('    v.uid: ', v.uid);
                    form_data.append(_pri.opts.pdf_tmp_id_pref + v.uid, v.fdata);
                    form_data.append(_pri.opts.pdf_tmp_id_pref + 'name-' + v.uid, v.fname);
                });
            }
        }

        $.extend(fd, _pri.getFormData());
        // set this after getFormData otherwise only the format radios are taken into account - not the is link only checkbox
        fd['job_format'] = _pri.getJobFormat();

        // due to gll img file upload we cannot use jquery here anymore ...
        // JW.Modal.get(_pri.opts.upl_html_url, form_data, _pri.onSaveHtml);

        var p;
        for (p in fd)
        {
            if (fd.hasOwnProperty(p))
            {
                form_data.append(p, fd[p]);
            }
        }

        // _pri.dbg('    form_data: ', form_data);

        // var headers = new Headers({"HTTP-X-REQUESTED-WITH": "XMLHttpRequest"});
        var xhr = new XMLHttpRequest();
        xhr.withCredentials = false;
        xhr.open('POST', _pri.opts.upl_html_url);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.addEventListener("load", function(e) {
            _pri.dbg('*** saveForm() on load e, xhr: ', e, xhr);
            _pri.onJsonResponse(xhr, 'saveForm');
        });

        xhr.send(form_data);
    };

    _pri.getFormData = function(preview)
    {
        var preview   = typeof preview === 'undefined' ? false : true;
        var form_data = {};
        if (preview)
        {
            form_data.form_act = 'preview';
        }
        else
        {
            form_data.form_act = 'save';
        }

        var inps = $('.jobfrm').find('input, select, textarea');
        var arr = inps.serializeArray();
        var len = arr.length;
        var i, o;
        for (i = 0; i < len; ++i)
        {
            o = arr[i];
            // _pri.dbg('    name, value ', o.name, o.value.toString());
            if (!form_data.hasOwnProperty(o.name))
            {
                form_data[o.name] = o.value.toString();
            }
            else
            {
                form_data[o.name] += ',' + o.value.toString();
            }
        }

        $.extend(form_data, _pri.clsacc.getFormData());

        if (_pri.isGll() && !preview)
        {
            inps = $('.jobfrm-gll').find('input');
            arr = inps.serializeArray();
            len = arr.length;
            for (i = 0; i < len; ++i)
            {
                o = arr[i];
                // _pri.dbg('    name, value ', o.name, o.value.toString());
                if (!form_data.hasOwnProperty(o.name))
                {
                    form_data[o.name] = o.value.toString();
                }
                else
                {
                    form_data[o.name] += ',' + o.value.toString();
                }
            }
            form_data.gll_file0_name = _pri.$gll_src_file_btn.find('.f-lbl').val();
        }

        return form_data;
    };

    _pri.extend();
    _pri.init();

    // expose public methods
    return publ;
};